import React from 'react';
import { CircularProgress, Stack, Typography } from '@mui/material';
import { palette, spaces } from '../../../../../assets/styles/themes/tokens';
import AnimatedEllipsis from './AnimatedEllipsis';

interface AIAssistantGeneratingIndicatorProps {
  text: string;
  dataTestId?: string;
}

const AIAssistantGeneratingIndicator: React.FC<AIAssistantGeneratingIndicatorProps> = ({
  text,
  dataTestId,
}) => (
  <Stack
    direction='row'
    gap={spaces.md}
    alignItems='center'
    sx={{ paddingTop: spaces.xs }}
    role='status'
    aria-live='polite'
  >
    <CircularProgress
      size={32}
      aria-hidden='true'
      sx={{ '& .MuiCircularProgress-svg': { width: 'auto', height: 'auto' } }}
    />
    <Typography variant='body2' sx={{ color: palette.text.secondary }} data-testid={dataTestId}>
      {text}<AnimatedEllipsis />
    </Typography>
  </Stack>
);

export default AIAssistantGeneratingIndicator;
